import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=b2e3e0ba"
import script from "./NoticeDetail.vue?vue&type=script&lang=ts"
export * from "./NoticeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports